/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StationsStationsUpdateMutationRequest, StationsStationsUpdateMutationResponse, StationsStationsUpdatePathParams } from "../models/StationsStationsUpdate";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { stationsStationsUpdate } from "../axios/stationsStationsUpdate";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const stationsStationsUpdateMutationKey = () => [{ url: '/stations/v1/:station' }] as const

export type StationsStationsUpdateMutationKey = ReturnType<typeof stationsStationsUpdateMutationKey>

export function stationsStationsUpdateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<StationsStationsUpdateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = stationsStationsUpdateMutationKey()
        return mutationOptions<StationsStationsUpdateMutationResponse, ResponseErrorConfig<Error>, {station: StationsStationsUpdatePathParams["station"], data: StationsStationsUpdateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ station, data }) => {
            return stationsStationsUpdate(station, data, config)
          },
        })

}

/**
 * @description Updates station properties such as name, language, and timezone.
 * @summary Update station
 * {@link /stations/v1/:station}
 */
export function useStationsStationsUpdate<TContext>(options: 
{
  mutation?: UseMutationOptions<StationsStationsUpdateMutationResponse, ResponseErrorConfig<Error>, {station: StationsStationsUpdatePathParams["station"], data: StationsStationsUpdateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<StationsStationsUpdateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? stationsStationsUpdateMutationKey()

          const baseOptions = stationsStationsUpdateMutationOptions(config) as UseMutationOptions<StationsStationsUpdateMutationResponse, ResponseErrorConfig<Error>, {station: StationsStationsUpdatePathParams["station"], data: StationsStationsUpdateMutationRequest}, TContext>
          

          return useMutation<StationsStationsUpdateMutationResponse, ResponseErrorConfig<Error>, {station: StationsStationsUpdatePathParams["station"], data: StationsStationsUpdateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<StationsStationsUpdateMutationResponse, ResponseErrorConfig<Error>, {station: StationsStationsUpdatePathParams["station"], data: StationsStationsUpdateMutationRequest}, TContext>
      
}